import { DeathAnscNotificationsNonResidentMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchDeathNonResidentNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-death-non-resident';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchDeathNonResidentNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchDeathNonResidentNotificationCivilStatusShared
        scope={IdAmbito.Mutazioni}
        items={DeathAnscNotificationsNonResidentMutationCrumbs()}
      />
    </Fragment>
  );
};

ResearchDeathNonResidentNotificationCivilStatusPage.displayName =
  'Research Death Non Resident Notifications Page component';

export default ResearchDeathNonResidentNotificationCivilStatusPage;
